import { Api } from 'utils';

class RevisionService {
  static getAreas = async (params = {}) => Api.createResponse('app/revision/areas', params);
  static saveWithPayment = async (params = {}) =>
    Api.createResponse('app/revision/save-payment', params);
  static save = async (params = {}) => Api.createResponse('app/revision/save', params);
  static saveResponse = async (params = {}) =>
    Api.createResponse('app/revision/save-response', params);
  static get = async (params = {}) => Api.createResponse('app/revision/', params);
  static getOne = async (params = {}) => Api.createResponse('app/revision/get-one', params);
  static rating = async (params = {}) => Api.createResponse('app/revision/rating', params);
  static changeStatus = async (params = {}) =>
    Api.createResponse('app/revision/change-status', params);
  static uploadDocument = async (params = {}) =>
    Api.createResponse('app/revision/upload-document', params);
  static view = async (params = {}) => Api.createResponse('app/revision/view', params);
  static sendComments = async (params = {}) =>
    Api.createResponse('app/revision/send-comments', params);
  static viewComments = async (params = {}) =>
    Api.createResponse('app/revision/view-comments', params);
  static acceptRevision = async (params = {}) =>
    Api.createResponse('app/revision/accept-revision', params);
  static acceptSearchRevision = async (params = {}) =>
    Api.createResponse('app/revision/accept-search-revision', params);

  static getDocumentsByArea = async (params = {}) =>
    Api.createResponse('app/revision/area-documents', params);

  static sendLawyerNotification = async (params = {}) =>
    Api.createResponse('app/revision/send-lawyer-notification', params);

  static getLawyerDetail = async (params = {}) =>
    Api.createResponse('app/revision/lawyer-detail', params);

  static createNoPayment = async (params = {}) =>
    Api.createResponse('app/revision/create-no-payment', params);
  static getSearchRevision = async (params = {}) =>
    Api.createResponse('app/revision/search-revision', params);

  static changeSearchRevisionStatus = async (params = {}) =>
    Api.createResponse('app/revision/change-search-revision-status', params);

  static getLawyers = async (params = {}) => Api.createResponse('app/revision/lawyers', params);

  static buyUse = async (params = {}) => Api.createResponse('app/revision/buy-use', params);

  static cancel = async (params = {}) => Api.createResponse('app/revision/cancel', params);

  static admin = {
    get: async (params?: any) => Api.createResponse('admin/revision/', params),
    getLawyers: async (params?: any) => Api.createResponse('admin/revision/lawyers', params),
    getAreas: async (params?: any) => Api.createResponse('admin/revision/areas', params),
    assignLawyer: async (params?: any) => Api.createResponse('admin/revision/assignLawyer', params),
  };
}

export default RevisionService;
